export default __webpack_public_path__ + "static/media/purely.804fafd7.png";